<script>
import { required, email } from 'vuelidate/lib/validators'
import { authComputed } from '@state/helpers'
import { giftlistApi } from '@router/apiFiles/giftlistApi'
import { chars } from '@state/modules/chars'



const mustBeAvailable = (value, vm) => ((vm.url.length > 0 && vm.urlIsAvailable == true) || vm.url.length == 0);


export default {
	data() {
		return {
			firstName1: '',
			lastName1: '',
			email1: this.currentUser().email,
			phone1: '',
			document1: '',
			firstName2: '',
			lastName2: '',
			email2: '',
			phone2: '',
			document2: '',
			url: '',
			urlIsAvailable: false
		}
	},
	validations: {
    	firstName1: { required },
    	lastName1: { required },
    	phone1: { required },
    	email1: { required },
    	document1: { required },
    	firstName2: { },
    	lastName2: { },
    	phone2: { },
    	email2: { },
		document2: { },
		url: { mustBeAvailable },
    	form: ['firstName1', 'lastName1', 'phone1', 'email1', 'document1', 'firstName2', 'lastName2', 'phone2', 'email2', 'document2', 'url' ],
	},
	mounted() {
		
	},
	methods: {
	  ...authComputed,
	  ...chars,
	  validate() {
		  this.$v.form.$touch()
		  var isValid = !this.$v.form.$invalid
		  this.$emit('on-validate', this.$data, isValid)
		  return isValid
		},
		onUrlTyping() {
			if (!/^[a-zA-Z-]+$/.test(this.url)) {
				this.url = this.url.replace(/[^a-z^A-Z^-]/g, "");
			}
		},		
		checkUrl() {
			var self = this;
			giftlistApi.checkIfUrlIsAvailable({ url: self.url }).then(function (data) {
				if (data == true) self.urlIsAvailable = true;
				else self.urlIsAvailable = false;
			});
		},
		createUrlSuggestion() {
			try {
				var self = this;
				giftlistApi.createUrlSuggestion({ Contact1_FirstName: self.firstName1, Contact1_LastName: self.lastName1, Contact2_FirstName: self.firstName2, Contact2_LastName: self.lastName2, EventType: null }).then(function (data) {
					if (data && data.suggestion) {
						self.url = data.suggestion;
						self.onUrlTyping();
						self.checkUrl();
					}
				});
			}
			catch {}
		}
	},
	watch: {
		url(newValue, oldValue) {
			this.urlIsAvailable = false;
		}
	}
}
</script>

<template>
	<div>

		<h4 class="header-title mt-0 mb-1">Contato principal</h4>
		<br />

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="Nome">
					<b-form-input
						v-model.trim="firstName1"
						:class="{ 'is-invalid': $v.firstName1.$error }"
						type="text"
						placeholder="Informe o nome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
					<span v-if="$v.firstName1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-6">
				<b-form-group label="Sobrenome">
					<b-form-input
						v-model.trim="lastName1"
						:class="{ 'is-invalid': $v.lastName1.$error }"
						type="text"
						placeholder="Informe o sobrenome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
					<span v-if="$v.lastName1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>
	
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Email">
					<b-form-input
						v-model.trim="email1"
						:class="{ 'is-invalid': $v.email1.$error }"
						type="text"
						placeholder="Informe o email"
						readonly
					></b-form-input>
					<span v-if="$v.email1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<b-form-group label="Celular">
					<b-form-input
						v-model.trim="phone1"
						:class="{ 'is-invalid': $v.phone1.$error }"
						type="text"
						v-model="phone1"
						v-mask="'(##) #####-####'"
						placeholder="Informe o celular"
					></b-form-input>
					<span v-if="$v.phone1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="CPF">
					<b-form-input
						v-model.trim="document1"
						:class="{ 'is-invalid': $v.document1.$error }"
						type="text"
						v-mask="'###.###.###-##'"
						v-model="document1"
						placeholder="Informe o CPF"
					></b-form-input>
					<span v-if="$v.document1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>

		<hr />
		<h4 class="header-title mt-0 mb-1">Contato secundário (opcional)</h4>
		<br />
		<b-alert show variant="light">O contato secundário é importante para que seja fácil encontrar a lista pelo nome. O contato secundário também recebe as notificações da lista.</b-alert>
		<br />

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="Nome">
					<b-form-input
						v-model.trim="firstName2"
						:class="{ 'is-invalid': $v.firstName2.$error }"
						type="text"
						placeholder="Informe o nome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
					<span v-if="$v.firstName2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-6">
				<b-form-group label="Sobrenome">
					<b-form-input
						v-model.trim="lastName2"
						:class="{ 'is-invalid': $v.lastName2.$error }"
						type="text"
						placeholder="Informe o sobrenome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
					<span v-if="$v.lastName2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>
	
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Email">
					<b-form-input
						v-model.trim="email2"
						:class="{ 'is-invalid': $v.email2.$error }"
						type="text"
						placeholder="Informe o email"
					></b-form-input>
					<span v-if="$v.email2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<b-form-group label="Celular">
					<b-form-input
						v-model.trim="phone2"
						:class="{ 'is-invalid': $v.phone2.$error }"
						type="text"
						v-model="phone2"
						v-mask="'(##) #####-####'"
						placeholder="Informe o celular"
					></b-form-input>
					<span v-if="$v.phone2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="CPF">
					<b-form-input
						v-model.trim="document2"
						:class="{ 'is-invalid': $v.document2.$error }"
						type="text"
						v-model="document2"
						v-mask="'###.###.###-##'"
						placeholder="Informe o CPF"
					></b-form-input>
					<span v-if="$v.document2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>


		<hr />
		<h4 class="header-title mt-0 mb-1">Link para acesso da lista</h4>
		<br />
		<b-alert show variant="light">Você pode criar um link personalizado para sua lista, fica mais fácil para os convidados. Clicando no botão a seguir nós sugerimos um link, que você pode alterá-lo como preferir, depois é só clicar no botão para vrificar a disponibilidade. <br /><div class="text-center"><br /><button type="button" @click="createUrlSuggestion()" class="btn btn-primary">Criar link personalizado</button></div></b-alert>
		<br />

		<div class="row">
			<div class="col-md-12">
				<b-form-group label="Link personalizado">
              		<b-input-group prepend="presentes.lavillecasa.com.br/lista/" class="mb-2 mr-sm-2 mb-sm-0">
              		  <b-input
						:class="{ 'is-invalid': $v.url.$error, 'is-valid': urlIsAvailable }"
						v-model.trim="url"
              		    placeholder="seu-link-personalizado"
						v-on:keyup="onUrlTyping()"
              		  ></b-input>
						<button type="button" @click="checkUrl()" class="btn btn-primary">Verificar disponibilidade</button>
              		</b-input-group>					
					<span v-if="$v.url.$error" class="help-block invalid-feedback">Indisponível</span>
				</b-form-group>
			</div>
		</div>

		<hr />
		<h4 class="header-title mt-0 mb-1">Imagem da lista</h4>
		<br />
		<b-alert show variant="light">Após criar a lista você poderá carregar uma imagem para que os convidados a encontrem com maior facilidade. <br /></b-alert>
		<br />

	</div>
</template>
